module.exports = __webpack_public_path__ + "static/media/gaas-g.29abd4af.mp3";